import { bindScanForms } from "@/lib/scan-form";
bindScanForms();